var React = require('react');

function IcHamburger (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21 7H3V5h18v2zm0 6H3v-2h18v2zM3 19h18v-2H3v2z","fill":"currentColor"}));
}

IcHamburger.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = IcHamburger;

IcHamburger.default = IcHamburger;
